import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { BaseSchema } from 'yup';
import { EMAIL_REGEX } from 'settings/regex';

export default (isUk: boolean, t: TFunction): BaseSchema =>
  Yup.object().shape({
    newEmail: Yup.string()
      .required(t('LABEL_ERROR_EMAIL_REQUIRED'))
      .email(t('LABEL_ERROR_INVALID_EMAIL'))
      .test(
        'email',
        t('LABEL_ERROR_EMAIL_REQUIRED', { ns: 'loginPage' }),
        function (value) {
          if (value !== undefined) {
            const isEmail = EMAIL_REGEX.test(value);
            const isNumeric = /^\d{8}$/.test(value);
            return isEmail || isNumeric;
          }
          return false;
        }
      )
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC')),
    password: Yup.string().required(t('LABEL_ERROR_PASSWORD_REQUIRED')),
  });
